var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "265.000000pt",
    height: "197.000000pt",
    viewBox: "0 0 265.000000 197.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,197.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 1515 l0 -305 -145 0 -145 0 0 -160 0 -159 143 -3 142 -3 3 -292 2 -293 150 0 150 0 0 295 0 295 254 0 c191 0 256 -3 263 -12 6 -7 63 -147 129 -311 l118 -298 29 3 c27 3 32 12 128 248 160 397 148 372 176 368 22 -3 37 -32 147 -298 67 -162 125 -301 129 -307 5 -7 19 -13 31 -13 22 0 35 28 147 308 l124 307 193 3 192 2 0 160 0 160 -125 0 c-69 0 -125 4 -125 8 0 5 54 141 119 303 l119 294 -161 3 c-89 1 -166 1 -172 -2 -6 -2 -64 -139 -129 -305 l-119 -301 -66 0 -66 0 -115 295 c-63 162 -119 295 -125 295 -5 0 -61 -133 -124 -295 l-114 -295 -66 0 -66 0 -120 305 -120 305 -392 0 -393 0 0 -305z m627 -152 l62 -153 -195 0 -194 0 0 155 0 156 133 -3 132 -3 62 -152z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit1);
export default __webpack_public_path__ + "static/media/credit1.d4a6d6b4243b9b06b3c0cf3e5032a328.svg";
export { ForwardRef as ReactComponent };